import React, { Component } from "react";
import { Form, Image } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import IconClose from "../../../assets/cross-icon.svg";
import CalendarFilter from "../../calendarFilter/CalendarFilter";
import { isFunction } from "lodash";
import { SearchComponent } from "../../../component/SearchComponent";
import { isValidArray, SORT_BY } from "../../../helper";
import { OTHER_CALENDER } from "../../../constant";

const issueListParams = {
  limit: 10,
  offset: 0,
  sortBy: "CREATED_DATE",
  sortOrder: "DESC",
  displayDateTitle: "- Created Date -"
};

export class ProjectSearchSorting extends Component {
  state = {
    search: "",
    sortStatus: false,
    sort: false,
    checkStatus: ""
  };

  getProperty(prop) {
    return this.hasOwnProperty(prop);
  }

  // value must be an object like { search: 'text' }
  onChange = value => {
    let { params } = this.props;
    let newParam = { ...params, ...value, offset: 0 };
    const fun = this.getProperty.bind(newParam);
    // extract params
    // now set params according to object key
    if (fun("search") || fun("projectGroupBy")) {
      newParam = { ...newParam, sortBy: null, sortOrder: null };
    }

    // if (fun("search")) {
    //   newParam["projectGroupBy"] = null;
    // }

    this.callApi({ ...newParam });
  };

  onHandleSort = () => {
    this.setState(prevState => ({ sortStatus: !prevState.sortStatus }));
  };

  onChangeSort = value => {
    const { params } = this.props;
    this.setState(
      prevState => ({ sortStatus: !prevState.sortStatus }),
      () => {
        this.callApi({
          ...params,
          checkStatus: value.name,
          projectGroupBy: null,
          sortBy: value.sortBy,
          sortOrder: value.sortOrder,
          offset: 0
        });
      }
    );
  };

  callApi = params => {
    const { callApiOnSuccess } = this.props;
    isFunction(callApiOnSuccess) && callApiOnSuccess({ ...params });
  };

  render() {
    const { sortStatus } = this.state;
    const { params = {}, sortBy = [] } = this.props;
    const { checkStatus, search, dates } = params;

    return (
      <React.Fragment>
        <div className="issue-list-exposed-filters">
          <div className="issue-list-filter-right">
            <CalendarFilter
              onChange={this.onChange}
              calenderOptions={OTHER_CALENDER}
              displayDateTitle={dates || "- Created Date -"}
            />
            <Form>
              <Form.Group className="search-box">
                <SearchComponent
                  keyName="searchText"
                  value={search}
                  onChange={value => {
                    this.onChange({ search: value.searchedText });
                  }}
                  delay={1000}
                />
              </Form.Group>
            </Form>
            {/* <div
              className={`agensort dropdown field-sort ${
                sortStatus ? "visible" : ""
              }`}
              onClick={this.onHandleSort}
            >
              <div
                className={`dropdown-overlay ${sortStatus ? "visible" : ""}`}
              />
              <div className="dropdown-selected-value">Sort</div>
              <div className="dropdown-option-list hidden-mobile">
                <div className="dropdown-option-list-heading">
                  <div className="list-sort">Sort By</div>
                  <Image src={IconClose} alt="Close Icon" />
                </div>
                {isValidArray(sortBy)
                  ? sortBy.map(value => {
                      return (
                        <div
                          onClick={e => {
                            e.stopPropagation();
                            this.onChangeSort(value);
                          }}
                          className={checkStatus === "high" ? "active" : ""}
                        >
                          {value.name}
                        </div>
                      );
                    })
                  : null}
              </div>
            </div> */}
          </div>
        </div>

        {/*For mobile*/}
        <div className="sort-section hidden-desktop">
          <div className={`sort-container ${sortStatus ? "visible" : ""}`}>
            <div className={`sort-popup ${sortStatus ? "visible" : ""}`}>
              <div className="popup-title">
                Sort By
                <button type="button" className="close">
                  <span aria-hidden="true" onClick={this.onHandleSort}>
                    ×
                  </span>
                </button>
              </div>
              <div className="popup-body">
                <ul>
                  <li>
                    <input
                      type="radio"
                      name="issue"
                      value="high"
                      onClick={e => {
                        e.stopPropagation();
                        this.onChangeSort("high");
                      }}
                    />{" "}
                    <b>High</b>&nbsp;Budget
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="issue"
                      value="low"
                      onClick={e => {
                        e.stopPropagation();
                        this.onChangeSort("low");
                      }}
                    />{" "}
                    <b>Low</b>&nbsp;Budget
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="issue"
                      value="latest"
                      onClick={e => {
                        e.stopPropagation();
                        this.onChangeSort("latest");
                      }}
                    />{" "}
                    <b>Latest</b>&nbsp;Created
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="issue"
                      value="old"
                      onClick={e => {
                        e.stopPropagation();
                        this.onChangeSort("old");
                      }}
                    />{" "}
                    <b>Old</b>&nbsp;Created
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/*For mobile*/}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectSearchSorting);
